// to close dropdown 
export const handleClose = (setAnchorEl) => {
    setAnchorEl(null);
    return null
};

module.export={handleClose}